import {
    AREA_DATA_FIELD,
    BUILDING_DATA_FIELD,
    COST_DATA_FIELD,
    COUNT_FIELD,
    DEPLOYMENT_STATUS_FIELD,
    DEVICES_BY_STATUS_REPORT_TITLE,
    PIE_CHART,
    ROOM_DATA_FIELD,
    TOTAL_COST_FIELD,
    UPDATED_AT_DATA_FIELD
} from "../../constants/reports_constants";
import ReportGenerator from "./report_generator";

export default class DevicesByStatusReportGenerator extends ReportGenerator {

    _getGraphTitle() {
        return DEVICES_BY_STATUS_REPORT_TITLE;
    }

    _hideUnusedColumns() {
        this._hideColumn(BUILDING_DATA_FIELD);
        this._hideColumn(COST_DATA_FIELD);
        this._hideColumn(COUNT_FIELD);
        this._hideColumn(ROOM_DATA_FIELD);
        this._hideColumn(TOTAL_COST_FIELD);
        this._hideColumn(UPDATED_AT_DATA_FIELD);
    }

    _showUsedColumns() {
        this._showColumn(AREA_DATA_FIELD);
        // this._showColumn(ROOM_DATA_FIELD);
        this._showColumn(DEPLOYMENT_STATUS_FIELD);
    }

    _getChartType() {
        return PIE_CHART;
    }

    /**
     * Override to provide filter predicate for this report
     * 
     * Returns a predicate function that returns true for devices, false for parts.
     * This is used by the base class with Array.filter().
     * 
     * @returns {Function} Predicate function that returns true for devices
     * @protected
     */
    _getFilterFunction() {
        // Return a predicate function that checks if an item is a device
        return (item) => item?.device?.device_type ? true : false;
    }

    /**
     * Override to exclude parts from table
     * 
     * Note: Filtering is handled by _getFilterFunction() in the base class.
     * The devices parameter is already filtered when it reaches this method.
     * 
     * @param {Array} devices - Array of devices (already filtered by base class)
     * @private
     */
    _tableAggregator(devices) {
        // Call parent implementation directly - devices are already filtered
        super._tableAggregator(devices);
    }

}